
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TagIcon from '@components/shared/icons/TagIcon.vue';
import IconNames from '@/config/IconNames';

@Component({
  name: 'TagIconPicker',
  components: {
    TagIcon
  }
})
export default class TagIconPicker extends Vue {
  @Prop()
  private value: string;

  @Prop({ default: false })
  private disabled: boolean;

  get icons() {
    return IconNames.names;
  }

  selectTag(icon) {
    if (!this.disabled) {
      this.$emit('input', icon);
    }
  }
}
